import React, { FC, ReactNode } from 'react';
import { Autocomplete as MuiAutocomplete, AutocompleteProps, InputAdornment, TextField } from '@mui/material';
import { AutocompleteRenderInputParams } from '@mui/material/Autocomplete/Autocomplete';

import { useTranslate } from 'src/shared/providers';

import { ChevronDownIcon } from './icons';

interface Props extends Omit<AutocompleteProps<any, any, any, any>, 'renderInput'> {
  placeholder?: string;
  popupStartIcon?: ReactNode;
  shrink?: boolean;
  renderInput?: (params: AutocompleteRenderInputParams) => React.ReactNode;
}

export const Autocomplete: FC<Props> = ({ placeholder, popupStartIcon, shrink = false, renderInput, ...props }) => {
  const { t } = useTranslate();

  const defaultRenderInput = (params: AutocompleteRenderInputParams) => (
    <TextField
      {...params}
      placeholder={placeholder}
      InputLabelProps={{ shrink }}
      InputProps={{
        ...params.InputProps,
        startAdornment: (
          <>
            <InputAdornment position="start">{popupStartIcon}</InputAdornment>
            {params.InputProps.startAdornment}
          </>
        ),
      }}
    />
  );

  return (
    <MuiAutocomplete
      {...props}
      popupIcon={<ChevronDownIcon color="#C2C9D1" />}
      noOptionsText={t('global.noOptions')}
      renderInput={renderInput || defaultRenderInput}
    />
  );
};
